// extracted by mini-css-extract-plugin
export default {"params":"Bbdqf","size-medium":"EXNMm","size-small":"INeXQ","value":"xGhX0"};